class InvalidSession extends Error {
  constructor (message = 'Sessão Inválida') {
    super(message)
  }
}

export default InvalidSession
